import {createBridge} from './bridge'

// export a bridge singleton
const bridge = createBridge()

export {bridge}

export const t = bridge.t
export const mdT = bridge.mdT
export const parseT = bridge.parseT
export const useT = bridge.useT
export const navigate = bridge.navigate
export const navigateModal = bridge.navigateModal
export const goBack = bridge.goBack
export const useLocation = bridge.useLocation
export const useParams = bridge.useParams
export const backend = bridge.backend
export const store = bridge.store
export const roles = bridge.roles
export const coreStatusColor = bridge.coreStatusColor
export const auth = bridge.auth
export const filters = bridge.filters
export const trackAnalyticsEvent = bridge.trackAnalyticsEvent
export const useSetQueryParams = bridge.useSetQueryParams
export const useQueryParams = bridge.useQueryParams

export const Link = bridge.Link
export const ModalLink = bridge.ModalLink
